import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { NextArrow } from 'src/features/white-labels/techcontemporary/app/components/banner/NextArrow';
import { PrevArrow } from 'src/features/white-labels/techcontemporary/app/components/banner/PrevArrow';
import { ImageWithText } from '../image-container';
import { StyledBannerContainer, StyledCarousel, StyledHeading, StyledTitleWrapper } from './styles';

export const Banner = () => {
    const { t } = useTranslation('tech-contemporary');

    const locale = useMemo(
        () => ({
            heading: t('landing.heading', {
                ns: 'tech-contemporary',
            }),
            subHeading: t('landing.sub-heading', {
                ns: 'tech-contemporary',
            }),
        }),
        [t]
    );

    const data = [
        {
            id: '1',
            url: '/whitelabel/tech-contemporary/slider_1.jpg',
            author: 'by DVK',
            title: 'Unveiling the Souls Whispers',
            type: 'Digital Art',
        },
        {
            id: '2',
            url: '/whitelabel/tech-contemporary/slider_2.jpg',
            author: 'by DVK',
            title: 'Temporal Threads of Creation',
            type: 'Digital Art',
        },
        {
            id: '3',
            url: '/whitelabel/tech-contemporary/slider_3.jpg',
            author: 'by BONDO',
            title: 'GOLDBOY',
            type: 'Digital Art',
        },
    ];

    return (
        <StyledBannerContainer>
            <StyledTitleWrapper>
                <StyledHeading variant="title" color="text">
                    {locale.heading}
                </StyledHeading>
            </StyledTitleWrapper>
            <StyledCarousel
                lg={1}
                md={1}
                sm={1}
                xl={1}
                xs={1}
                noWheel
                slidesToShow={1}
                slidesToScroll={1}
                infinite
                initialSlide={0}
                autoplay
                fade
                arrows
                nextArrow={<NextArrow />}
                prevArrow={<PrevArrow />}
            >
                {data.map((item) => (
                    <ImageWithText
                        imageUrl={item.url}
                        key={item.id}
                        author={item.author}
                        title={item.title}
                        type={item.type}
                    />
                ))}
            </StyledCarousel>
        </StyledBannerContainer>
    );
};